import axios from 'axios'
// На облаке (сборка с REACT_APP_API_URL='') запросы идут на тот же домен — crm.ctg.school/api/...
// Локально (npm start) переменной нет → ходим на локальный бэкенд localhost:4000.
const API_BASE = process.env.REACT_APP_API_URL != null ? process.env.REACT_APP_API_URL : 'http://localhost:4000'
const API = axios.create({ baseURL: API_BASE })
API.interceptors.request.use((config) => { const token = localStorage.getItem('token'); if (token) config.headers.Authorization = 'Bearer ' + token; return config })

// Токен живёт 8 часов (JWT_SECRET, index.js) — если комп/браузер закрыли дольше
// (11.07, жалоба Антона: «после выключения компьютера страница не работает,
// приходится жать выйти и заново заходить»), сервер начинает отвечать 401 на
// все запросы, а страница молча ломается (пустые данные/вечная загрузка),
// потому что раньше это никак не отслеживалось. Теперь при 401 сами чистим
// протухший токен и перезагружаем страницу — App.js увидит role=null и
// покажет форму входа автоматически, без ручного «Выйти».
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('name')
      if (!window.location.pathname.includes('login')) {
        window.location.reload()
      }
    }
    return Promise.reject(error)
  }
)

export const login = (login, password) => API.post('/api/login', { login, password })
export const getDeals = () => API.get('/api/deals')
export const getTasks = () => API.get('/api/tasks')
export const getCalls = () => API.get('/api/calls')
export const getStudents = () => API.get('/api/students')
export const getMkTasks = () => API.get('/api/mktasks')
export const getPayments = () => API.get('/api/payments/invoices')
export const getClasses = () => API.get('/api/classes')
export const getLessons = () => API.get('/api/lessons')
export default API
